<script setup>
    import emitter from '../assets/js/eventBus';
    import { useRoute } from "vue-router";
    import { computed } from 'vue';
    import { useStore } from "vuex";

    const store = useStore();

    const darkMode = computed(() => store.state.darkMode);

    const openType = (type) => {
        emitter.emit('set-type', { data: type });
    }

    const getRoute = (n) => {
        const route = useRoute();
        const routeArr = route.path.split("/");
        return routeArr[n];
    };


</script>

<template>
    <div class="d-none" v-bind:class="{
                                'd-xl-block': (getRoute(1) !== 'login' && getRoute(1) !== 'cadastro')
                            }">
        <div class="dropdown quick-action dropup">
            <button class="btn btn-secondary rounded-5 shadow-lg" type="button" data-bs-toggle="dropdown" aria-expanded="false" v-tooltip="{
                            content: 'Adicionar Transação',
                            distance: 15
                        }">
                <i class="fal fa-plus-circle fa-2x"></i>
            </button>
            <ul class="dropdown-menu">
                <li>
                    <a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('despesa')">
                        <i class="fas fa-minus me-2 text-danger"></i>
                        Despesa
                    </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                    <a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('receita')">
                        <i class="fal fa-plus me-2 text-success"></i>
                        Receita
                    </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                    <a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('transferência')">
                        <i class="fal fa-exchange-alt me-2 text-warning"></i>
                        Transferência
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<style>
    .quick-action {
        position: fixed !important;
        top: 90%;
        right: 0.5%;
        padding: 10px;
        z-index: 10000000;
        width: 100px;
    }

    .quick-action .btn{
        background-color: #d18536;
        color: #fff;
    }

    .quick-action .btn:focus, .quick-action .btn:active, .quick-action .btn:hover{
        background-color: #0c2b3a;
        color: #d18536;
    }

</style>